import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import Form from "assets/scripts/components/common/form/Form/Form";
import { default as DecedentRelationshipFormGroup } from "assets/scripts/components/common/form/DecedentRelationshipFormGroup/DecedentRelationshipFormGroup";
import { ERRORS } from "../../../constants/FormMessages";
const messages = defineMessages({
    submit: {
        id: "forms.relationship.submit",
        defaultMessage: "Save"
    }
});
export default class RelationshipForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = (relationship) => this.setState({ relationship });
        this.state = {
            relationship: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state: value } = this;
        const isValid = value.relationship !== "";
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.relationship.legend" defaultMessage="Relationship Form"/>
						</span>
					</legend>

					<DecedentRelationshipFormGroup name="relationship" value={value.relationship} onChange={this._handleChange} error={isValid ? null : ERRORS.SELECT} backendError={backendErrors.decedentRelationship} required/>
				</fieldset>
			</Form>);
    }
    _handleSubmit() {
        this.props.updateRelationship(this.props.accountId, this.state.relationship);
        this.props.closeModal();
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/RelationshipForm.tsx